import React from 'react'

import {FaInstagram} from 'react-icons/fa'
import {FaFacebookSquare} from 'react-icons/fa'
import {FaTwitterSquare} from 'react-icons/fa'
import {RiUnsplashFill} from 'react-icons/ri'
import {FaMobileAlt} from 'react-icons/fa'
import {MdEmail} from 'react-icons/md'

import './icons.css'

const Icons = () => {
    return (
        <div className="footer">
            <div className="icons-group">
                <h4 className="icon"><FaInstagram /></h4>
                <h4 className="icon"><FaFacebookSquare /></h4>
                <h4 className="icon"><FaTwitterSquare /></h4>
                <h4 className="icon"><RiUnsplashFill /></h4>
                <h4 className="icon"><FaMobileAlt /></h4>
                <h4 className="icon"><MdEmail /></h4>
            


            </div>
            
            <div className="copyright-text">© Mahbub Khan. All rights reserved.</div>
            


        </div>

    )
}

export default Icons
